const getters = {
  pointto: state => state.pointto,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js